// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import VueJsonp from 'vue-jsonp'
import VueSlideUpDown from 'vue-slide-up-down'
import App from './App'
import router from './router'
import CONSTANT from './config/constants'
import Http from './plugins/Http'
import {store} from './store'

import './assets/css/bootstrap.css'
import './assets/css/kbucall_web_m.css'

Vue.config.productionTip = false
Vue.prototype.$eventBus = new Vue()
Vue.prototype.CONSTANT = CONSTANT

Vue.use(VueCookies)
Vue.use(VueJsonp)
Vue.use(Http);
Vue.component('vue-slide-up-down', VueSlideUpDown)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js